// extracted by mini-css-extract-plugin
module.exports = {"FancyButton":"FancyButton_FancyButton__2Unte"};